<template>
	<v-modal class="v-modal--switch-to-phone">
		<template v-slot:header>
			<h1 class="alpha">Switch To Phone</h1>
		</template>
		<div class="editorial center">
			<p class="alpha highlight-text">Want to continue on your phone?</p>
			<p class="beta">Simply scan this QR code for instant login.</p>
		</div>
		<img
			:src="'data:image/svg+xml;base64,' + qrCode"/>
		<template v-slot:footer>
			<ul class="actions actions--right">
				<li>
					<button
						class="button button--text"
						@click.prevent="$vmodal.close()">Close
					</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	props: {
		qrCode: {
			required: true,
			type: String,
		},
	},
};
</script>
